export default "__VITE_ASSET__65281beb__"